import { API } from 'aws-amplify';
import React from 'react';
import { toast } from 'react-toastify';
import { t } from 'i18next';

const useStatusChange = (appInstId, status) => {
    const [statuses, setStatuses] = React.useState([]);
    const [doingAjax, setDoingAjax] = React.useState(true);

    const retrieveStatuses = async () => {
        setDoingAjax(true);

        try {
            let response = await API.get('ShipyardAPI', `/statuschange/statuses/${status}`);

            setStatuses(response.statuses);

            setDoingAjax(false);
        } catch (e) {
            toast.error(t('General.AjaxError'));
        }
    };

    const changeStatus = async (newStatus, returnReason) => {
        setDoingAjax(true);
        let successful = true;

        try {
            await API.patch('ShipyardAPI', `/statuschange/${appInstId}`, {
                body: {
                    newStatusId: newStatus,
                    changeReason: !!returnReason ? returnReason : null,
                },
            });
        } catch (e) {
            toast.error('Failed to change status.');
            successful = false;
        } finally {
            setDoingAjax(false);
        }

        return successful;
    };

    return {
        statuses,
        doingAjax,
        retrieveStatuses,
        changeStatus,
    };
};

export default useStatusChange;
